export const ru = {
    'banners-max-selected': 'Выберите до {maxCount} объявлений, чтобы их отредактировать',
    'banners-tab-name': 'Объявления',
    'campaigns-tab-name': 'Кампании',
    'export-to-excel-no-banners': 'В кампании нет объявлений',
    'export-to-excel-no-banners-in-group': {
        one: 'В группе нет объявлений',
        some: 'В группах нет объявлений',
        many: 'В группах нет объявлений',
        none: 'В группах нет объявлений'
    },
    'export-to-excel-tooltip': 'Экспорт возможен только в рамках одной кампании',
    'feed-filters-tab-name': 'Фильтры фидов',
    'groups-max-selected': 'Выберите до {maxCount} групп, чтобы их отредактировать',
    'groups-tab-name': 'Группы',
    'phrases-tab-name': 'Фразы',
    'retargetings-tab-name': 'Ретаргетинг и аудитории',
    'search-and-replace-forbidden-for-relevance-match': 'Поиск и замена невозможны для автотаргетинга',
    'select-campaigns': 'Выберите кампании',
    'targetings-tab-name': 'Условия показа',
    'users-profile-tab-name': 'Профили пользователей'
};
